import { graphql } from 'react-apollo'
import getCountry from '../../helpers/get-country'
import { ApplicationError } from '../../helpers/errors'
import query from './query.graphql'

const mapPropsToOptions = ({ staticContext }) => {
  const country = getCountry(staticContext)

  return {
    variables: { slugQuery: `fields.country=${country}` },
    errorPolicy: 'ignore',
  }
}

const mapDataToProps = ({ data: { error, loading, nationalHomepages } }) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }
  return {
    promotion: nationalHomepages[0].promotionModule,
  }
}

const withNationalPromotion = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withNationalPromotion
